import  NoteReducer from './note/NoteReducer'

// 所有的redux管理的 state
const rootReducer = {
    // rehydrated,
    noteState: NoteReducer,
};
export default rootReducer;
